// extracted by mini-css-extract-plugin
export default {"firstSection":"Podian_firstSection__TkD5V","secondSection":"Podian_secondSection__368mO"};